import React, { useEffect, useRef, useState } from "react";
import HeaderContainer from "./HeaderContainer";
import FooterContainer from "./FooterContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Form, Modal, Table } from "react-bootstrap";
import formatearCantidad from "../funciones/convertirAMoneda";
import usePayment from "../hooks/usePayment";
import DatePicker from "react-datepicker";
import { addDetailPayment } from "../firebase/firebaseOps";

const PaymentsDetailContainer = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const { p } = location.state || {};
    const payment = usePayment(id)?.sort((a,b)=>a.date-b.date);
    const amount = p.amount;
    const [show, setShow] = useState(false);
    const [date, setDate] = useState(new Date());
    const [amountInput, setAmountInput] = useState('');
    const amountInputRef = useRef(null);

    useEffect(()=>{
        if(show) {
            amountInputRef.current.focus();
        }
    }, [show])

    const handleClose = () => {
        setShow(false);
        setDate(new Date());
        setAmountInput('');
    };
    const handleShow = () => setShow(true);

    const handleBackClick = () => { navigate('/monthlyPayments'); }

    const handleAddPayment = () => {
        handleClose();
        
        addDetailPayment(Math.round(date/1000), amountInput, id)
            .then(()=>{
                handleClose();
            })
            .catch((e)=>{
                console.log(e);
            });
    }

    // Initialize remaining amount 
    let remainingAmount = amount;

    return (
        <>
            <HeaderContainer title="Detalle de Apartado"></HeaderContainer>
            <div>
                <h1>Nombre: {p.name}</h1>
                <h2>Artículo: {p.desc}</h2>
                <h2>Valor: {formatearCantidad(p.amount)}</h2>
                <h2>Lugar: {p.place}</h2>
                <h2>Categoría: {p.type}</h2>
                <br></br>
                <h3>Lista de abonos</h3>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Fecha</th>
                            <th>Monto</th>
                            <th>Saldo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            payment && payment.map((d, idx) => {
                                remainingAmount -= d.amount;
                                return (
                                    <tr key={idx}>
                                        <td>{new Date(d.date*1000).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' })}</td>
                                        <td>{formatearCantidad(d.amount)}</td>                                        
                                        <td>{formatearCantidad(remainingAmount)}</td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </Table>
                {
                    (remainingAmount !==0)?<Button onClick={handleShow}>Agregar Abono</Button>:null
                }
                <Button style={{marginLeft: "5px"}} onClick={handleBackClick}>Regresar</Button>
                
            </div>
            <FooterContainer />

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Abono</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formDate">
                            <Form.Label>Fecha</Form.Label>
                            <DatePicker selected={date} onChange={(date) => setDate(date)} className="form-control" />
                        </Form.Group>
                        <Form.Group controlId="formAmount">
                            <Form.Label>Monto</Form.Label>
                            <Form.Control
                                type="number"
                                value={amountInput}
                                onChange={(e) => setAmountInput(e.target.value)}
                                placeholder="Ingrese el monto"
                                ref={amountInputRef}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleAddPayment}>
                        Agregar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default PaymentsDetailContainer;